<!--Navbar-->
<mdb-navbar
  *ngIf="checkValidPath()"
  SideClass="navbar navbar-expand-lg navbar-dark navbar-webtext"
>
  <div style="width: 100%; display: flex">
    <mdb-navbar-brand>
      <a class="navbar-brand" routerLink="/">
        <img
          class="d-inline-block align-top logo"
          src="/assets/images/webtext_logo.png"
          alt=""
        />
      </a>
    </mdb-navbar-brand>

    <mdb-icon
      fas
      icon="angle-left"
      size="lg"
      class="text-white mr-auto d-flex d-md-none align-self-center"
    ></mdb-icon>

    <links>
      <ul class="navbar-nav mr-auto">
        <li class="nav-item">
          <a
            class="nav-link waves-light"
            [ngClass]="{ active: location.path() === '/dashboard' }"
            routerLink="/"
            mdbWavesEffect
            >Dashboard<span class="sr-only"></span
          ></a>
        </li>

        <li class="nav-item dropdown" dropdown>
          <a
            dropdownToggle
            mdbWavesEffect
            type="button"
            class="nav-link dropdown-toggle waves-light"
            mdbWavesEffect
          >
            Messaging<span class="caret"></span
          ></a>
          <div
            *dropdownMenu
            class="dropdown-menu dropdown dropdown-primary"
            role="menu"
          >
            <a
              class="dropdown-item waves-light"
              mdbWavesEffect
              *ngIf="checkRole('basic_compose')"
              [ngClass]="{
                'nav-active': location.path() === '/compose-message'
              }"
              routerLink="/compose-message"
              >Compose Message</a
            >
            <a
              class="dropdown-item waves-light"
              mdbWavesEffect
              [ngClass]="{ 'nav-active': location.path() === '/outbox' }"
              routerLink="/outbox"
              >Sent Messages (MT)</a
            >
            <a
              class="dropdown-item waves-light"
              mdbWavesEffect
              [ngClass]="{ 'nav-active': location.path() === '/inbox' }"
              routerLink="/inbox"
              >Received Messages (MO)</a
            >
            <a
              class="dropdown-item waves-light"
              *ngIf="checkRole('manage_tmpl')"
              [ngClass]="{ 'nav-active': location.path() === '/templates' }"
              mdbWavesEffect
              routerLink="/templates"
              >Message Templates</a
            >
            <a
              class="dropdown-item waves-light"
              mdbWavesEffect
              *ngIf="checkRole('manage_kw')"
              [ngClass]="{
                'nav-active': location.path() === '/keyword-management'
              }"
              routerLink="/keyword-management"
              >Keyword Management</a
            >
          </div>
        </li>

        <li class="nav-item">
          <a
            class="nav-link waves-light"
            *ngIf="checkRole('manage_open_hours')"
            [ngClass]="{
              'nav-active': location.path() === '/hours-of-operation'
            }"
            routerLink="/hours-of-operation"
            mdbWavesEffect
            >Hours of Operation<span class="sr-only"></span
          ></a>
        </li>

        <!-- <li class="nav-item">
          <a
            class="nav-link waves-light"
            [ngClass]="{ 'nav-active': location.path() === '/dpm-admin' }"
            routerLink="/dpm-admin"
            *ngIf="checkRole('dpm_admin')"
            mdbWavesEffect
            >DPM Admin</a
          >
        </li> -->

        <!-- <li class="nav-item">
          <a
            class="nav-link waves-light"
            [ngClass]="{ 'nav-active': location.path() === '/support' }"
            routerLink="/support"
            mdbWavesEffect
            >Support</a
          >
        </li> -->

        <!-- CX Hub (Not yet enabled) -->
        <!-- <li class="nav-item dropdown" dropdown>
        <a dropdownToggle class="nav-link waves-light" class="nav-link dropdown-toggle waves-light"
         mdbWavesEffect >CX Hub<span class="caret"></span></a>
          <div *dropdownMenu class="dropdown-menu dropdown dropdown-primary" role="menu">
            <a class="dropdown-item waves-light" mdbWavesEffect routerLink="/hub-config">Hub Config</a>
            <a class="dropdown-item waves-light" mdbWavesEffect>Hub Statistics</a>
            </div>
      </li> -->

        <!-- Self-Provisioning (Not yet enabled) -->
        <li class="nav-item dropdown" dropdown>
          <a
            dropdownToggle
            mdbWavesEffect
            type="button"
            class="nav-link dropdown-toggle waves-light"
            mdbWavesEffect
          >
            Provisioning<span class="caret"></span
          ></a>
          <div
            *dropdownMenu
            class="dropdown-menu dropdown dropdown-primary"
            role="menu"
          >
            <!-- <a
              class="dropdown-item waves-light"
              mdbWavesEffect
              routerLink="/self-provisioning"
              >Self-Provisioning</a
            > -->
            <a
              class="dropdown-item waves-light"
              mdbWavesEffect
              routerLink="/provisioned-numbers"
              >Provisioned Numbers</a
            >
          </div>
        </li>
      </ul>

      <ul class="navbar-nav">
        <li class="nav-item dropdown" dropdown>
          <a
            dropdownToggle
            mdbWavesEffect
            type="button"
            class="nav-link dropdown-toggle waves-light"
            mdbWavesEffect
          >
            {{ email }}<span class="caret"></span
          ></a>
          <div
            *dropdownMenu
            class="dropdown-menu dropdown dropdown-primary"
            role="menu"
          >
            <div class="dropdown-item waves-light" mdbWavesEffect>
              <mat-slide-toggle
                [checked]="isDarkTheme"
                color="primary"
                (click)="$event.stopPropagation()"
                (change)="toggleTheme()"
                >Dark mode</mat-slide-toggle
              >
            </div>
            <div
              class="dropdown-item waves-light"
              [routerLink]="['/change-password']"
              mdbWavesEffect
            >
              Change password
            </div>
            <a
              class="dropdown-item waves-light"
              (click)="logout()"
              mdbWavesEffect
              >Logout</a
            >
          </div>
        </li>
      </ul>
    </links>
  </div>
</mdb-navbar>
<div class="site-content">
  <ng-content></ng-content>
</div>
